import Regulamin from "../../../pages-v1/Regulamin";

export const Page = Regulamin;
